import services from './../../services/service'; // Service Class
import MainHeader from './../Main-Header/index.vue'; // Main Header
import Sidebar from './../Sidebar/index.vue'; // Dashboard Header
import MainFooter from './../Main-Footer/index.vue'; // Main Footer
let service = new services();

export default {
    name: 'Dashboard',
    data () {
        return {
            activities:{},
            searches: {},
            search: {},
            users: {},
            cnpros: {},
            cnpro: {},
            businesses:[],
            cnsurvey: {},
            forums: {},
            reviews: {},
            img_url: service.imageURL
        }
    },
    components: {
        'component-header': MainHeader,
        'component-sidebar': Sidebar,
        'component-footer': MainFooter
    },
    methods: {

    doSearch(){
            var credentials = {
                search_type: this.search.type,
                search_keywords: this.search.keywords,
                search_city: this.search.city
            }

            let navi = this.$router;

            if(credentials.search_type != null || credentials.search_keywords != null) {
                if(credentials.search_type == "businesses") {
                    //use local storage for now
                    localStorage.setItem("cityneeds_search_type", this.search.type);
                    localStorage.setItem("cityneeds_search_keywords", this.search.keywords);
                    localStorage.setItem("cityneeds_search_city", this.search.city);
                    navi.push("business-search");
                }
                else if(credentials.search_type == "cnpros") {
                    //use local storage for now
                    localStorage.setItem("cityneeds_search_type", this.search.type);
                    localStorage.setItem("cityneeds_search_keywords", this.search.keywords);
                    localStorage.setItem("cityneeds_search_city", this.search.city);
                    navi.push("cnpro-search");
                }
           }else {
                toastr.error('Kindly fill all fields', 'Warning!');
            }
        
    },

    //search cnpro by category
    doSearch2(category){
        let navi = this.$router;
        localStorage.setItem("cityneeds_search_type", 'cnpros');
        localStorage.setItem("cityneeds_search_keywords", category);
        localStorage.setItem("cityneeds_search_city", 'Abuja');
        navi.push("cnpro-search");
           
    },
    
    //cnpros
    viewCnpro(cnpro){
        if(cnpro) {
            localStorage.setItem("cityneeds_search_cnpro", cnpro.cnpro_data_item); //use local storage for now
            this.$router.push("cnpro");
        }
        
    },
    //get all saved listings
    getUsers() {
        service.getUsers(this).then(data => {
           if(data.body.status == 200) {
                this.users = data.body.data;
             }
        }).catch((err) => {
            if(err) {
                toastr.error('Sorry, could not process information', 'Warning!');
            }
        })
    },
    getCnpros() {
        service.getAllCnpros(this).then(data => {
            if(data.body.status == 200) {
                this.cnpros = data.body.data;
            }
        }).catch((err) => {
            if(err) {
                 //toastr.error('Sorry, could not process information', 'Warning!');
            }
        })
    },

    //businesses
    viewBusiness(business){
        if(business) {
            localStorage.setItem("cityneeds_search_business", business.business_data_item); //use local storage for now
            this.$router.push("businesses");
        }
        
    },
    getBusinesses() {
        service.getAllBusinesses(this).then(data => {
            if(data.body.status == 200) {
                this.businesses = data.body.data;
                //limi to 6
                // let length = 0;
                // let datan = data.body.data;
                // datan.forEach(function(element) {
                //     if(length <= 5){
                //         this.businesses.push(element);
                //     }
                //     length++;  
                // }, this);
                
                  
                
            }
        }).catch((err) => {
            if(err) {
                 //toastr.error('Sorry, could not process information', 'Warning!');
            }
        })
    },

    //forums
    getForums() {
        service.getAllForums(this).then(data => {
            if(data.body.status == 200) {
                this.forums = data.body.data;
            }
        }).catch((err) => {
            if(err) {
                 //toastr.error('Sorry, could not process information', 'Warning!');
            }
        })
    },

    //reviews
    getReviews() {
        service.getAllReviews(this).then(data => {
            if(data.body.status == 200) {
                this.reviews = data.body.data;
            }
        }).catch((err) => {
            if(err) {
                 //toastr.error('Sorry, could not process information', 'Warning!');
            }
        })
    },

    //activities
    getActivities() {
        service.getActivities(this).then(data => {
            if(data.body.status == 200) {
                this.activities = data.body.data;
            }
        }).catch((err) => {
            if(err) {
                 //toastr.error('Sorry, could not process information', 'Warning!');
            }
        })
    },

    //get and update paga data
    getPagaServicesRemoteXX(){
        //get Paga merchants
        service.pagaGetMerchants(this).then(response => {
            service.postPagaMerchants(this,response.body.billers).then(response => {
                //console.log(response.body.status); 
            }).catch((err) => {
                this.loading = false;
                //console.log(err)
            })
        }).catch((err) => {
            this.loading = false;
            // console.log(err)
        })

        //get Paga Mobile Operators
        service.pagaGetMobileOperators(this).then(response => {
            service.postPagaMobileOperators(this,response.body.operators).then(response => {
                //console.log(response.body.status); 
            }).catch((err) => {
                this.loading = false;
               // console.log(err)
            })
        }).catch((err) => {
                this.loading = false;
                //console.log(err)
        })
    },

    //updated--01
    getPagaServicesRemote(){
        //get Paga merchants
        let seek_url = service.paga_apiBaseUrl+'getMerchants';
        var payload = {
            "referenceNumber": this.getDefaultRandomNumbers(),
        }
        let hash = service.SHA512(payload.referenceNumber+service.paga_apiKey);
        service.getPagaRequest(this,payload,seek_url,hash).then(data => {
            if(data.body.responseCode == 0){
                let data_load = [];
                let load = data.body.merchants;
                for(let item of load){
                    data_load.push(item);
                }
                service.postPagaMerchants(this,data_load).then(response => {
                    //console.log(response.body.status); 
                }).catch((err) => {
                    this.loading = false;
                    //console.log(err)
                })
            }
        }).catch((err) => {
            this.loading = false;
            // console.log(err)
        })

        //get Paga Mobile Operators
        let seek_url_2 = service.paga_apiBaseUrl+'getMobileOperators';
        var payload = {
            "referenceNumber": this.getDefaultRandomNumbers(),
        }
        let hash_2 = service.SHA512(payload.referenceNumber+service.paga_apiKey);
        service.getPagaRequest(this,payload,seek_url_2,hash_2).then(data => {
            if(data.body.responseCode == 0){
                let data_load = [];
                let load = data.body.mobileOperator;
                for(let item of load){
                    data_load.push(item);
                }
                service.postPagaMobileOperators(this,data_load).then(response => {
                    //console.log(response.body.status); 
                }).catch((err) => {
                    this.loading = false;
                // console.log(err)
                })
            }
        }).catch((err) => {
                this.loading = false;
                //console.log(err)
        })
    },

    //
    getDefaultRandomNumbers(){
        return Math.floor(100000000 + Math.random() * 900000000); //9 digit non-zero leading number
    },
},
created: function(){
    this.getUsers();
    this.getCnpros();
    this.getBusinesses();
    this.getForums();
    this.getReviews();
    this.getActivities();
    this.getPagaServicesRemote();
}
}


// WEBPACK FOOTER //
// ./src/components/Dashboard/script.js